import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'uxd-design-system-components';
import './CheckList.scss';

const CheckList = ({
  listItems,
  checkedItems,
  onChangeHandler,
  labelId,
  label,
  labelNote,
}) => (
  <>
    <label
      data-testid="checklist-label"
      htmlFor={labelId}
      className="checkList-label"
    >
      {label}
      <span>{labelNote}</span>
    </label>
    {listItems.map((item) => (
      <Checkbox
        id={item}
        key={item}
        label={item}
        name={item}
        checked={checkedItems.indexOf(item) > -1}
        onChange={onChangeHandler}
      />
    ))}
  </>
);

CheckList.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  checkedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  labelId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelNote: PropTypes.string.isRequired,
};

export default CheckList;
